import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import inputStyles from "assets/jss/material-dashboard-pro-react/components/customInputStyle.js";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const style = {
    infoText: {
        fontWeight: "300",
        textAlign: "center"
    },
    infoDescription: {
        margin: "0 0 30px",
        textAlign: "center",
        opacity: .5
    },
    ...selectStyles,
    ...inputStyles,
    ...regularFormsStyle,
};


class Step1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            clientId: this.props.clientId,
            companyName: this.props.companyName,
            companyId: this.props.companyId,
            gender: this.props.gender,
            firstName: this.props.firstName,
            lastName: this.props.lastName,
            position: this.props.position,
            street: this.props.street,
            zipCode: this.props.zipCode,
            city: this.props.city,
            phone: this.props.phone,
        };
    }

    sendState() {
        return this.state;
    }

    isValidated(){
        const {
            companyName,
            firstName,
            lastName,
            position,
            street,
            zipCode,
            city,
        } = this.state;
        return companyName.length > 3 && firstName.length > 1 && lastName.length > 1 && position.length > 1 && street.length > 4 && zipCode.length > 3 && city.length > 3;

    }

    render() {
        const {
            gender,
            companyName,
            clientId,
            firstName,
            lastName,
            position,
            street,
            zipCode,
            city,
            phone
        } = this.state;
        const {classes} = this.props;
        return (
            <GridContainer justify="center">

                {/* HEADER */}
                <GridItem xs={12}>
                    <h4 className={classes.infoText}>
                        Ansprechpartner <code style={{marginLeft: 10}}>{clientId}</code>
                    </h4>
                    <p className={classes.infoDescription}>
                        Bitte prüfe die Angaben zum Kunden
                    </p>
                </GridItem>

                {/* CONTACT INFORMATION */}
                <GridItem xs={12} md={5}>
                    <GridContainer>

                        {/* GENDER SELECT */}
                        <GridItem xs={12}>
                            <FormControl
                                fullWidth
                                className={classes.selectFormControl}
                            >
                                <Select
                                    MenuProps={{
                                        className: classes.selectMenu
                                    }}
                                    classes={{
                                        select: classes.select
                                    }}
                                    value={gender}
                                    onChange={ e => e && this.setState({ gender: e.target.value }) }
                                    inputProps={{
                                        name: "genderSelect",
                                        id: "genderSelect"
                                    }}
                                >
                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelected
                                        }}
                                        value="male"
                                    >
                                        Herr
                                    </MenuItem>
                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelected
                                        }}
                                        value="female"
                                    >
                                        Frau
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </GridItem>

                        {/* COMPANY NAME */}
                        <GridItem xs={12}>
                            <CustomInput
                                labelText="Firma"
                                success={companyName.length > 3}
                                error={companyName.length < 4}
                                id="companyNameInput"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: e => this.setState({ companyName: e.target.value }),
                                    value: companyName
                                }}
                            />
                        </GridItem>

                        {/* FIRST NAME */}
                        <GridItem xs={12}>
                            <CustomInput
                                labelText="Vorname"
                                success={firstName.length > 1}
                                error={firstName.length < 2}
                                id="firstNameInput"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: e => this.setState({ firstName: e.target.value }),
                                    value: firstName
                                }}
                            />
                        </GridItem>

                        {/* LAST NAME */}
                        <GridItem xs={12}>
                            <CustomInput
                                labelText="Nachname"
                                success={lastName.length > 1}
                                error={lastName.length < 2}
                                id="lastNameInput"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: e => this.setState({ lastName: e.target.value }),
                                    value: lastName
                                }}
                            />
                        </GridItem>

                        {/* POSITION */}
                        <GridItem xs={12}>
                            <CustomInput
                                labelText="Position"
                                success={position.length > 1}
                                error={position.length < 2}
                                id="positionInput"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: e => this.setState({ position: e.target.value }),
                                    value: position
                                }}
                            />
                        </GridItem>
                    </GridContainer>
                </GridItem>

                {/* ADDRESS */}
                <GridItem xs={12} md={5}>
                    <GridContainer>
                        {/* STREET */}
                        <GridItem xs={12}>
                            <CustomInput
                                labelText="Straße"
                                success={street.length > 4}
                                error={street.length < 5}
                                id="streetInput"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: e => this.setState({ street: e.target.value }),
                                    value: street
                                }}
                            />
                        </GridItem>

                        {/* ZIP CODE */}
                        <GridItem xs={12}>
                            <CustomInput
                                labelText="PLZ"
                                success={zipCode.length > 3}
                                error={zipCode.length < 4}
                                id="zipCodeInput"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: e => this.setState({ zipCode: e.target.value }),
                                    value: zipCode
                                }}
                            />
                        </GridItem>

                        {/* ZIP CODE */}
                        <GridItem xs={12}>
                            <CustomInput
                                labelText="Stadt"
                                success={city.length > 3}
                                error={city.length < 4}
                                id="cityInput"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: e => this.setState({ city: e.target.value }),
                                    value: city
                                }}
                            />
                        </GridItem>

                        {/* PHONE */}
                        <GridItem xs={12}>
                            <CustomInput
                                labelText="Telefon"
                                id="phoneInput"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: e => this.setState({ phone: e.target.value }),
                                    value: phone
                                }}
                            />
                        </GridItem>
                    </GridContainer>
                </GridItem>
            </GridContainer>
        );
    }
}

Step1.propTypes = {
    classes: PropTypes.object
};

export default withStyles(style)(Step1);
